import React from "react";
import ContactForm from "./ContactForm";
import FAQSection from "./FAQSection";

interface HelpSupportProps {
  className?: string;
}

const HelpSupport: React.FC<HelpSupportProps> = ({ className = "" }) => {

  return (
    <div className={`w-full flex flex-col gap-8 max-w-5xl mx-auto p-4 ${className}`}>
      {/* FAQ Section with Header and Quick Actions */}
      <FAQSection />
      
      {/* Contact Form Section */}
      <ContactForm />
    </div>
  );
};

export default HelpSupport;
